import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/BlogSection/BlogSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/Share/Share.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/blog.jpg");
